import { ConnectomeNode } from '@/shared/model/connectome-node.model';
import { MapNode } from '@/shared/model/map-node.model';
import axios from 'axios';
import { Module } from 'vuex';
import { ContextualMemoryCollection } from '@/shared/model/contextual-memory-collection.model';
import { BinaryExpression } from '@/shared/model/binary-expression.model';
import { MapLink } from '@/shared/model/map-link.model';
import { MapTarget } from '@/shared/model/map-target.model';
import { MapLinkInfo } from '@/shared/model/map-link-info.model';
import moment from 'moment';

const baseCollectionsApiUrl = '/api/collections';
const postCreateTmpCollectionURL = baseCollectionsApiUrl + '/tmp/create';

const baseConnectomesApiUrl = '/api/connectome';
const postConnectomeByScrapboardIdsURL = baseConnectomesApiUrl + '/map';
const postInvestmentGraphURL = baseConnectomesApiUrl + '/spoc/mapByQuery';

export const shapeSize = 200;
export const shapeSizes = [shapeSize * 1.8, shapeSize, shapeSize * 0.8, shapeSize * 0.5];
export const mainPalette = ['#e34d1c', '#e34d1c', '#e34d1c', '#fbba32', '#fbba32', '#fbba32', '#fbba32', '#fbba32', '#807dba', '#238b45'];
export const mainPalette_v2 = ['#e34d1c', '#fbba32', '#807dba', '#238b45'];
const spocMainPalette = [
  '#87a9ff',
  '#72b300',
  '#7872e3',
  '#018f2a',
  '#0083f4',
  '#b99a00',
  '#01b0f9',
  '#da7be4',
  '#00a99d',
  '#f39532',
  '#00803a',
  '#c36b48',
  '#FFD700',
  '#8f6220',
  '#da480c',
  '#6c7a00',
];
export const mainPalettev3 = ['#e34d1c', '#fbba32', '#807dba', ...spocMainPalette];
export const mapBackgroundColor = ['#2F2C29', '#2F2C29'];

export const nodeFillColors = new Map([
  ['DEFAULT', mainPalettev3],
  ['SELECTED', mainPalettev3],
  ['HOVER', mainPalettev3],
  ['SECONDARYSELECTED', mainPalettev3],
  ['UNSELECTED', mainPalettev3],
  ['HIDE', mainPalettev3],
]);

export const thematicRange = [
  [0.0, 0.1],
  [0.1, 0.2],
  [0.2, 0.5],
  [0.5, 1.2],
  [1.2, Number.MAX_VALUE],
];

const spocNodeSizes = [
  [1, 2, 3, 6, 9],
  [1, 2, 3, 6, 9],
  [1, 2, 3, 6, 9],
  [1, 2, 3, 6, 9],
  [1, 2, 3, 6, 9],
  [1, 2, 3, 6, 9],
  [1, 2, 3, 6, 9],
  [1, 2, 3, 6, 9],
  [1, 2, 3, 6, 9],
  [1, 2, 3, 6, 9],
  [1, 2, 3, 6, 9],
  [1, 2, 3, 6, 9],
  [1, 2, 3, 6, 9],
  [1, 2, 3, 6, 9],
  [3, 4, 6, 9, 14],
  [1, 2, 3, 6, 9],
];
export const nodeSizes = [[3, 4, 6, 9, 14], [1, 3, 4, 8, 9], [1, 1, 3, 5, 7], ...spocNodeSizes];

const spocNodeMinSizes = [4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 6, 4];
export const nodeMinSizes = [6, 4, 2, ...spocNodeMinSizes];
const spocNodeMaxSizes = [20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 35, 20];
export const nodeMaxSizes = [35, 20, 10, ...spocNodeMaxSizes];
const spocNodeFontMaxSizesLv0 = [24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24];
const spocNodeFontMaxSizesLv1 = [20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20];
const spocNodeFontMaxSizesLv2 = [16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16];
const spocNodeFontMaxSizesLv3 = [14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14];
const spocNodeFontMaxSizesLv4 = [8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8];
export const nodeFontMaxSizes = [
  [60, 24, 20, ...spocNodeFontMaxSizesLv0],
  [30, 20, 18, ...spocNodeFontMaxSizesLv1],
  [20, 16, 14, ...spocNodeFontMaxSizesLv2],
  [18, 14, 12, ...spocNodeFontMaxSizesLv3],
  [17, 8, 8, ...spocNodeFontMaxSizesLv4],
];

const spocNodeFontMinSizes = [6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6];
export const nodeFontMinSizes = [
  [8, 6, 4, ...spocNodeFontMinSizes],
  [8, 6, 4, ...spocNodeFontMinSizes],
  [8, 6, 4, ...spocNodeFontMinSizes],
  [8, 6, 4, ...spocNodeFontMinSizes],
  [8, 6, 4, ...spocNodeFontMinSizes],
];

const spocNodeFontSizesDefaultLv0 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
const spocNodeFontSizesDefaultLv1 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
const spocNodeFontSizesDefaultLv2 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8, 8, 8, 0];
const spocNodeFontSizesDefaultLv3 = [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10];
const spocNodeFontSizesDefaultLv4 = [22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22];

const spocNodeFontSizesSelectedLv0 = [22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22];
const spocNodeFontSizesSelectedLv1 = [14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14];
const spocNodeFontSizesSelectedLv2 = [12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12];
const spocNodeFontSizesSelectedLv3 = [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10];
const spocNodeFontSizesSelectedLv4 = [22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22];

const spocNodeFontSizesHoverLv0 = [22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22];
const spocNodeFontSizesHoverLv1 = [14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14];
const spocNodeFontSizesHoverLv2 = [12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12];
const spocNodeFontSizesHoverLv3 = [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10];
const spocNodeFontSizesHoverLv4 = [22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22];

const spocNodeFontSizesSecondarySelectedLv0 = [14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14];
const spocNodeFontSizesSecondarySelectedLv1 = [14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14];
const spocNodeFontSizesSecondarySelectedLv2 = [12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12];
const spocNodeFontSizesSecondarySelectedLv3 = [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10];
const spocNodeFontSizesSecondarySelectedLv4 = [22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22];

const spocNodeFontSizesUnSelectedLv0 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
const spocNodeFontSizesUnSelectedLv1 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
const spocNodeFontSizesUnSelectedLv2 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
const spocNodeFontSizesUnSelectedLv3 = [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10];
const spocNodeFontSizesUnSelectedLv4 = [20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20];

const spocNodeFontSizesHideLv0 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
const spocNodeFontSizeHideLv1 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
const spocNodeFontSizesHideLv2 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
const spocNodeFontSizesHideLv3 = [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10];
const spocNodeFontSizesHideLv4 = [20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20];

export const nodeFontSizes = new Map([
  [
    'DEFAULT',
    [
      [16, 0, 0, ...spocNodeFontSizesDefaultLv0],
      [16, 0, 0, ...spocNodeFontSizesDefaultLv1],
      [14, 0, 0, ...spocNodeFontSizesDefaultLv2],
      [12, 0, 0, ...spocNodeFontSizesDefaultLv3],
      [26, 16, 12, ...spocNodeFontSizesDefaultLv4],
    ],
  ],
  [
    'SELECTED',
    [
      [20, 18, 18, ...spocNodeFontSizesSelectedLv0],
      [20, 18, 18, ...spocNodeFontSizesSelectedLv1],
      [18, 16, 16, ...spocNodeFontSizesSelectedLv2],
      [12, 8, 8, ...spocNodeFontSizesSelectedLv3],
      [26, 22, 22, ...spocNodeFontSizesSelectedLv4],
    ],
  ],
  [
    'HOVER',
    [
      [20, 18, 18, ...spocNodeFontSizesHoverLv0],
      [20, 18, 18, ...spocNodeFontSizesHoverLv1],
      [18, 16, 16, ...spocNodeFontSizesHoverLv2],
      [14, 9, 9, ...spocNodeFontSizesHoverLv3],
      [26, 22, 22, ...spocNodeFontSizesHoverLv4],
    ],
  ],
  [
    'SECONDARYSELECTED',
    [
      [20, 20, 20, ...spocNodeFontSizesSecondarySelectedLv0],
      [20, 18, 18, ...spocNodeFontSizesSecondarySelectedLv1],
      [18, 16, 16, ...spocNodeFontSizesSecondarySelectedLv2],
      [12, 8, 8, ...spocNodeFontSizesSecondarySelectedLv3],
      [26, 22, 22, ...spocNodeFontSizesSecondarySelectedLv4],
    ],
  ],
  [
    'UNSELECTED',
    [
      [20, 0, 0, ...spocNodeFontSizesUnSelectedLv0],
      [20, 0, 0, ...spocNodeFontSizesUnSelectedLv1],
      [16, 0, 0, ...spocNodeFontSizesUnSelectedLv2],
      [12, 0, 0, ...spocNodeFontSizesUnSelectedLv3],
      [26, 20, 20, ...spocNodeFontSizesUnSelectedLv4],
    ],
  ],
  [
    'HIDE',
    [
      [0, 0, 0, ...spocNodeFontSizesHideLv0],
      [0, 0, 0, ...spocNodeFontSizeHideLv1],
      [0, 0, 0, ...spocNodeFontSizesHideLv2],
      [0, 0, 0, ...spocNodeFontSizesHideLv3],
      [0, 0, 0, ...spocNodeFontSizesHideLv4],
    ],
  ],
]);
export const linkFontSize = [0, 0, 0, 8, 12];
export const linkFontMaxSizes = [24, 20, 16, 12, 12];
export const linkFontMinSizes = [4, 4, 4, 4, 4];
const spocLinkFontFillColor = [
  '#F0FFF0',
  '#F0FFF0',
  '#F0FFF0',
  '#F0FFF0',
  '#F0FFF0',
  '#F0FFF0',
  '#F0FFF0',
  '#F0FFF0',
  '#F0FFF0',
  '#F0FFF0',
  '#F0FFF0',
  '#F0FFF0',
  '#F0FFF0',
  '#F0FFF0',
  '#F0FFF0',
  '#F0FFF0',
];
export const linkFontFillColor = ['#F0FFF0', '#F0FFF0', '#F0FFF0', ...spocLinkFontFillColor];
const spocLinkFontContourColor = [
  '#32CD32',
  '#32CD32',
  '#32CD32',
  '#32CD32',
  '#32CD32',
  '#32CD32',
  '#32CD32',
  '#32CD32',
  '#32CD32',
  '#32CD32',
  '#32CD32',
  '#32CD32',
  '#32CD32',
  '#32CD32',
  '#32CD32',
  '#32CD32',
];
export const linkFontContourColor = ['#32CD32', '#32CD32', '#32CD32', ...spocLinkFontContourColor];
export const linkPrimarySelectedFillColors = [['#32CD32'], ['#32CD32'], ['#32CD32']];
const spocNodePrimarySelectedContourColors = [
  '#32CD32',
  '#32CD32',
  '#32CD32',
  '#32CD32',
  '#32CD32',
  '#32CD32',
  '#32CD32',
  '#32CD32',
  '#32CD32',
  '#32CD32',
  '#32CD32',
  '#32CD32',
  '#32CD32',
  '#32CD32',
  '#32CD32',
  '#32CD32',
];
export const nodePrimarySelectedContourColors = [
  ['#9ebcda', '#9ebcda', '#9ebcda', '#9ebcda', '#9ebcda'],
  ['#fc4e2a', '#fc4e2a', '#fc4e2a', '#fc4e2a', '#fc4e2a', '#fc4e2a', '#fc4e2a', '#fc4e2a', '#fc4e2a', '#fc4e2a'],
  ['#32CD32', '#32CD32', '#32CD32', ...spocNodePrimarySelectedContourColors],
];

export const fontDefaultSizes = [null, null, [32, 28, 28]];
export const fontHoverSizes = [null, null, [34, 34, 34]];
export const fontPrimarySelectedSizes = [null, null, [34, 30, 30]];
export const fontSecondarySelectedSizes = [null, null, [32, 28, 28]];
export const fontUnselectedSizes = [null, null, [32, 28, 28]];

export const nodeDefaultFillColors = [['#8c96c6', '#8c6bb1', '#88419d', '#810f7c', '#4d004b'], mainPalette, mainPalette_v2];
export const nodeDefaultContourColors = [['#8c96c6', '#8c6bb1', '#88419d', '#810f7c', '#4d004b'], mainPalette, mainPalette_v2];
export const nodeDefaultSizes = [[150, 120, 110, 100, 90], [180, 180, 180, 160, 160, 160, 160, 160, 150, 120], shapeSizes];

const spocFontDefaultFillColors = [
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
];
export const fontDefaultFillColors = [
  ['#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff'],
  ['#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff'],
  ['#ffffff', '#ffffff', '#ffffff', ...spocFontDefaultFillColors],
];

const spocFontDefaultContourColors = [
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
];
export const fontDefaultContourColors = [
  ['#4d004b', '#4d004b', '#4d004b', '#4d004b', '#4d004b'],
  ['#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000'],
  ['#000000', '#000000', '#000000', ...spocFontDefaultContourColors],
];

export const nodeHoverFillColors = [['#8c96c6', '#8c96c6', '#8c96c6', '#8c96c6', '#8c96c6'], mainPalette, mainPalettev3];
export const nodeHoverContourColors = [[null, null, null, null, null], mainPalette, mainPalettev3];
export const nodeHoverSizes = [[160, 130, 120, 110, 100], [190, 190, 190, 170, 170, 170, 170, 170, 160, 130], shapeSizes];

const spocFontHoverFillColors = [
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
];
export const fontHoverFillColors = [
  ['#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff'],
  ['#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff'],
  ['#ffffff', '#ffffff', '#ffffff', ...spocFontHoverFillColors],
];
const spocFontHoverContourColors = [
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
];
export const fontHoverContourColors = [
  ['#4d004b', '#4d004b', '#4d004b', '#4d004b', '#4d004b'],
  ['#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000'],
  ['#000000', '#000000', '#000000', ...spocFontHoverContourColors],
];

export const nodePrimarySelectedFillColors = [['#8c96c6', '#8c96c6', '#8c96c6', '#8c96c6', '#8c96c6'], mainPalette, mainPalettev3];

export const nodePrimarySelectedSizes = [[160, 130, 120, 110, 100], [190, 190, 190, 170, 170, 170, 170, 170, 160, 130], shapeSizes];

const spocFontPrimarySelectedFillColors = [
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
];
export const fontPrimarySelectedFillColors = [
  ['#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff'],
  ['#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff'],
  ['#ffffff', '#ffffff', '#ffffff', ...spocFontPrimarySelectedFillColors],
];
const spocFontPrimarySelectedContourColors = [
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
];
export const fontPrimarySelectedContourColors = [
  ['#4d004b', '#4d004b', '#4d004b', '#4d004b', '#4d004b'],
  ['#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000'],
  ['#000000', '#000000', '#000000', ...spocFontPrimarySelectedContourColors],
];

export const nodeSecondarySelectedFillColors = [['#8c96c6', '#8c96c6', '#8c96c6', '#8c96c6', '#8c96c6'], mainPalette, mainPalettev3];
export const nodeSecondarySelectedContourColors = [
  [null, null, null, null, null],
  ['#cb181d', '#cb181d', '#cb181d', '#cb181d', '#cb181d', '#cb181d', '#cb181d', '#cb181d', '#cb181d', '#cb181d'],
  ['#cb181d', '#cb181d', '#cb181d', '#cb181d'],
];
export const nodeSecondarySelectedSizes = [[150, 120, 110, 100, 90], [180, 180, 180, 160, 160, 160, 160, 160, 150, 120], shapeSizes];

const spocFontSecondarySelectedFillColors = [
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
];
export const fontSecondarySelectedFillColors = [
  ['#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff'],
  ['#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff'],
  ['#ffffff', '#ffffff', '#ffffff', ...spocFontSecondarySelectedFillColors],
];

const spocFontSecondarySelectedContourColors = [
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
];
export const fontSecondarySelectedContourColors = [
  ['#4d004b', '#4d004b', '#4d004b', '#4d004b', '#4d004b'],
  ['#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000'],
  ['#000000', '#000000', '#000000', ...spocFontSecondarySelectedContourColors],
];

export const nodeUnselectedFillColors = [['#8c96c6', '#8c6bb1', '#88419d', '#810f7c', '#4d004b'], mainPalette, mainPalette_v2];
export const nodeUnselectedContourColors = [['#8c96c6', '#8c6bb1', '#88419d', '#810f7c', '#4d004b'], mainPalette, mainPalette_v2];
export const nodeUnselectedSizes = [[150, 120, 110, 100, 90], [140, 140, 140, 120, 120, 120, 120, 120, 100, 90], shapeSizes];
const spocFontUnselectedFillColors = [
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
  '#ffffff',
];
export const fontUnselectedFillColors = [
  ['#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff'],
  ['#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff'],
  ['#ffffff', '#ffffff', '#ffffff', ...spocFontUnselectedFillColors],
];

const spocFontUnselectedContourColors = [
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
];
export const fontUnselectedContourColors = [
  ['#4d004b', '#4d004b', '#4d004b', '#4d004b', '#4d004b'],
  ['#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000'],
  ['#000000', '#000000', '#000000', ...spocFontUnselectedContourColors],
];

export const linkDefaultFillColors = [['#5c5c5c'], ['#5c5c5c'], ['#5c5c5c']];
export const linkDefaultContourColors = [[null], [null], ['#5c5c5c']];
export const linkDefaultSizes = [[], [], [28]];

export const linkHoverFillColors = [['#9ebcda'], ['#fd8d3c'], ['#fd8d3c']];
export const linkHoverContourColors = [[null], [null], [null]];
export const linkHoverSizes = [[], [], [38]];

export const linkPrimarySelectedContourColors = [['#9ebcda'], ['#5c5c5c'], ['#9d9d9d']];
export const linkPrimarySelectedSizes = [[], [], [56]];
export const linkPrimarySelectedFontSizes = [null, null, [26, 24, 24]];

export const linkSecondarySelectedFillColors = [['#9ebcda'], ['#5c5c5c'], ['#9d9d9d']];
export const linkSecondarySelectedContourColors = [['#5c5c5c'], ['#5c5c5c'], ['#5c5c5c']];
export const linkSecondarySelectedSizes = [[], [], [30]];
export const linkSecondarySelectedFontSizes = [null, null, [26, 24, 24]];

export const linkUnselectedFillColors = [['#5c5c5c'], ['#5c5c5c'], ['#5c5c5c']];
export const linkUnselectedContourColors = [[null], [null], [null]];
export const linkUnselectedSizes = [[], [], [24]];

export const thematicClass = new Map<string, Array<number>>([
  ['XSMALL', [0, 0.001, 0.002]],
  ['SMALL', [0, 0.001, 0.002]],
  ['MEDIUM', [0, 0.005, 0.01]],
  ['LARGE', [0, 0.008, 0.015]],
  ['XLARGE', [0, 0.01, 0.02]],
  ['INFINITE', [0, 0.01, 0.02]],
]);

//LOADING, ERROR, EMPTY, DRAWING, READY, SEARCHING

export const connectomeStatus: string[] = ['LOADING', 'ERROR', 'EMPTY', 'DRAWING', 'READY', 'SEARCHING'];
export interface MapStorable {
  nodesSelected: Array<MapNode>;
  nodesLinkedSelected: Set<string>;
  nodes: Array<MapNode>;
  currentMapSignatureLoaded: string;
  mapSignatureRequested: string;
  //originNodes: Array<MapNode>;
  nodesSelectedChanged: number;
  nodesChanged: number;
  mapChanged: number;
  reloadData: number;
  viewBy: string;
  reSize: number;
  fitToscreen: number;
  fitToSelected: number;
  zoomIn: number;
  zoomOut: number;
  rankFilter: number;
  applyFilter: number;
  status: string;
  searchTerms: string;
  centerToNode: number;
  nodeToCenter: MapNode | null;
  show: boolean;
  connectomeDate: string;
  //waitingData: boolean;
  //firstLoading: boolean;
  //preNodesSelected: Array<MapNode>;
}

export const mapStore: Module<MapStorable, any> = {
  namespaced: true,
  state: {
    nodesSelected: new Array<MapNode>(),
    nodesLinkedSelected: new Set<string>(),
    nodes: new Array<MapNode>(),
    currentMapSignatureLoaded: '',
    mapSignatureRequested: '',
    //originNodes: new Array<MapNode>(),
    nodesSelectedChanged: 0,
    nodesChanged: 0,
    mapChanged: 0,
    reloadData: 0,
    viewBy: 'TOPICS',
    reSize: 0,
    fitToscreen: 0,
    fitToSelected: 0,
    zoomIn: 0,
    zoomOut: 0,
    rankFilter: 100,
    applyFilter: 0,
    status: '',
    searchTerms: '',
    centerToNode: 0,
    nodeToCenter: null,
    show: false,
    connectomeDate: '',
    //waitingData: false,
    //firstLoading: true,
    //preNodesSelected: new Array<MapNode>(),
  },
  getters: {
    getNodesSelected: state => state.nodesSelected,
    getDataNodesSelected: state => {
      if (!state.nodesSelected) {
        return { status: 'NOK', message: 'nodes selected not defined', result: new Array<any>() };
      }

      if (state.nodesSelected.length == 0) {
        return { status: 'OK', message: 'no nodes seleted', result: new Array<any>() };
      }
      const selectionIds = new Set<string>();
      const selection = new Set<MapNode>();
      // state.preNodesSelected.forEach(node => {
      //   selectionIds.add(node.id);
      //   selection.add(node.data);
      // });
      state.nodesSelected.forEach(node => {
        if (!selectionIds.has(node.id)) {
          selection.add(node);
        }
      });
      const result = {
        status: 'OK',
        message: 'data selected',
        result: Array.from(selection),
      };
      return result;
    },
    getNodesSuggestionsByKeywords: state => {
      const listNodes = new Array<MapNode>();
      if (!state.nodes || state.nodes?.length == 0) {
        return listNodes;
      }

      if (!state.searchTerms || state.searchTerms.length < 3) {
        return listNodes;
      }

      const regOption = new RegExp(state.searchTerms, 'ig');
      listNodes.push(...state.nodes.filter(vertex => vertex.label.match(regOption)).slice(0, 3));

      return listNodes;
    },
    getNodesLinkedSelected: state => state.nodesLinkedSelected,
    getNodes: state => state.nodes,
    //getOriginNodes: state => state.originNodes,
    nodesSelectedHaveChanged: state => state.nodesSelectedChanged,
    nodesHaveChanged: state => state.nodesChanged,
    mapHaveChanged: state => state.mapChanged,
    reloadDataRequested: state => state.reloadData,
    getViewBy: state => state.viewBy,
    resizeRequested: state => state.reSize,
    fitToScreenRequested: state => state.fitToscreen,
    fitToSelectedRequested: state => state.fitToSelected,
    zoomInRequested: state => state.zoomIn,
    zoomOutRequested: state => state.zoomOut,
    getRankFilter: state => state.rankFilter,
    getApplyFilter: state => state.applyFilter,
    getCurrentMapSignatureLoaded: state => state.currentMapSignatureLoaded,
    getMapSignatureRequested: state => state.mapSignatureRequested,
    getStatus: state => state.status,
    centerToNodeRequested: state => state.centerToNode,
    getNodeToCenter: state => state.nodeToCenter,
    isShow: state => state.show,
    getConnectomeDate: state => state.connectomeDate,
    //isWaitingData: state => state.waitingData,
    //isFirstLoading: state => state.firstLoading,
  },
  mutations: {
    setNewMap(state, payload: { newNodes: Array<MapNode> }) {
      //state.waitingData = true;
      // if (!payload) {
      //   this.commit('setWaitingData', false);
      //   //state.waitingData = false;
      //   state.nodesChanged++;
      //   //console.log('CHASE WaitingData *****[SVO]*****/(^^)/ setNewMap  payload null', state.waitingData);
      //   return;
      // }
      //console.log('*****[SVO]*****/(^^)/ setNewMap payload ', payload);
      // const newOriginNodes = JSON.stringify(payload.newNodes.origin);
      // const newNodes = JSON.stringify(payload.newNodes.last);
      // const newPreNodesSelected = JSON.stringify(payload.newNodes.preSet);

      // const currentOriginNodes = JSON.stringify(state.originNodes);
      // const currentNodes = JSON.stringify(state.nodes);
      // const currentPreNodesSelected = JSON.stringify(state.preNodesSelected);

      // if (!payload.newNodes?.origin || !payload.newNodes?.last || payload.newNodes.last.length < 1) {
      //   //this.commit('setWaitingData',false);
      //   state.waitingData = false;
      //   //console.log('CHASE WaitingData *****[SVO]*****/(^^)/ setNewMap connectomeEmpty', state.waitingData);
      //   state.preNodesSelected = new Array<MapNode>();
      //   state.nodes = new Array<MapNode>();
      //   state.originNodes = new Array<MapNode>();
      //   state.mapChanged++;
      //   return;
      // }

      // if (
      //   newOriginNodes.localeCompare(currentOriginNodes) == 0 &&
      //   newNodes.localeCompare(currentNodes) == 0 &&
      //   newPreNodesSelected.localeCompare(currentPreNodesSelected) == 0
      // ) {
      //   // console.log('*****[SVO]*****/(^^)/ setNewMap newOriginNodes ', newOriginNodes);
      //   // console.log('*****[SVO]*****/(^^)/ setNewMap newNodes ', newNodes);
      //   // console.log('*****[SVO]*****/(^^)/ setNewMap newPreNodesSelected ', newPreNodesSelected);

      //   // console.log('*****[SVO]*****/(^^)/ setNewMap currentOriginNodes ', currentOriginNodes);
      //   // console.log('*****[SVO]*****/(^^)/ setNewMap currentNodes ', currentNodes);
      //   // console.log('*****[SVO]*****/(^^)/ setNewMap currentPreNodesSelected ', currentPreNodesSelected);
      //   state.waitingData = false;
      //   //this.commit('setWaitingData',false);
      //   console.log('CHASE WaitingData *****[SVO]*****/(^^)/ setNewMap  same connectome', state.waitingData);
      //   state.nodesChanged++;
      //   return;
      // }

      //console.log(payload.newNodes.origin);
      // state.preNodesSelected = new Array<MapNode>();
      state.nodes = new Array<MapNode>();
      //state.originNodes = new Array<MapNode>();

      //state.originNodes = payload.newNodes.origin.map(x => new MapNode(x));
      state.nodes = payload.newNodes.map(x => new MapNode(x));
      //state.preNodesSelected = payload.newNodes.preSet.map(x => new MapNode(x));
      //console.log('CHASE WaitingData *****[SVO]*****/(^^)/ setNewMap map updated', state.waitingData);
      state.mapChanged++;
    },
    setCurrentMapSignatureLoaded(state, payload: { newMapSignature: string }) {
      if (!payload) {
        return;
      }

      if (!payload.newMapSignature) {
        state.currentMapSignatureLoaded = '';
        return;
      }
      state.currentMapSignatureLoaded = payload.newMapSignature;
    },
    setMapSignatureRequested(state, payload: { newMapSignature: string }) {
      if (!payload) {
        return;
      }
      if (!payload.newMapSignature) {
        state.mapSignatureRequested = '';
        return;
      }
      state.mapSignatureRequested = payload.newMapSignature;
    },
    setNodesSelected(state, payload: { newNodesSelected: Array<MapNode> }) {
      if (!payload) {
        return;
      }

      if (!payload.newNodesSelected || payload.newNodesSelected.length < 1) {
        state.nodesSelected = new Array<MapNode>();
        state.nodesLinkedSelected = new Set<string>();
        return;
      }
      state.nodesSelected = payload.newNodesSelected.map(x => x);
      state.nodesLinkedSelected = new Set<string>();
      payload.newNodesSelected.forEach(selected => {
        if (selected.nodesLinked?.length > 0) {
          selected.nodesLinked.forEach(nodeLinked => {
            state.nodesLinkedSelected.add(nodeLinked);
          });
        }
      });

      state.nodesSelectedChanged++;
    },
    // setPreNodesSelected(state, payload: { newPreNodesSelected: Array<MapNode> }) {
    //   if (!payload) {
    //     return;
    //   }

    //   if (!payload.newPreNodesSelected || payload.newPreNodesSelected.length < 1) {
    //     state.preNodesSelected = new Array<MapNode>();
    //     return;
    //   }
    //   state.preNodesSelected = payload.newPreNodesSelected.map(x => x);
    // },
    toggleNodesSelected(state, payload: { newNodesSelected: Array<MapNode> }) {
      if (!payload) {
        return;
      }

      if (!payload.newNodesSelected || payload.newNodesSelected.length < 1) {
        state.nodesSelected = new Array<MapNode>();
        state.nodesLinkedSelected = new Set<string>();
        return;
      }

      if (!state.nodesSelected) {
        state.nodesSelected = new Array<MapNode>();
      }

      payload.newNodesSelected.forEach(newNode => {
        if (!newNode.id) {
          return;
        }

        const index = state.nodesSelected.findIndex(x => x.id === newNode.id);

        if (index == -1) {
          state.nodesSelected.push(new MapNode(newNode));
        } else {
          state.nodesSelected.splice(index, 1);
        }
      });

      state.nodesLinkedSelected = new Set<string>();
      state.nodesSelected.forEach(newNode => {
        if (newNode.nodesLinked?.length > 0) {
          newNode.setNodesLinked.forEach(nodeLinked => {
            state.nodesLinkedSelected.add(nodeLinked);
          });
        }
      });

      state.nodesSelectedChanged++;
    },
    setViewBy(state, newView: string) {
      if (!newView) return;
      state.viewBy = newView;
    },
    resetMapData(state) {
      state.nodesSelected = new Array<MapNode>();

      state.nodesLinkedSelected = new Set<string>();
      state.nodes = new Array<MapNode>();
      // state.preNodesSelected = new Array<MapNode>();
      state.nodesSelectedChanged = 0;
      state.nodesChanged = 0;
      state.mapChanged = 0;
      // state.waitingData = false;
      //console.log('CHASE WaitingData *****[SVO]*****/(^^)/ resetMapData', state.waitingData);
      state.viewBy = 'TOPICS';
      //console.log('map reset')
      state.nodeToCenter = null;
      state.centerToNode = 0;
      state.currentMapSignatureLoaded = '';
    },
    reloadDataRequest(state) {
      console.log('CHASE Reload *****[SVO]*****/(^^)/ resetMapData', state.reloadData);
      state.reloadData++;
    },
    requestResize(state) {
      state.reSize++;
      console.log('CHASE Request reszie ', state.reSize);
    },
    requestFitToScreen(state) {
      state.fitToscreen++;
    },
    requestFitToSelected(state) {
      state.fitToSelected++;
    },
    requestZoomIn(state) {
      state.zoomIn++;
    },
    requestZoomOut(state) {
      state.zoomOut++;
    },
    setRankFilter(state, newRankFilter: number) {
      if (!newRankFilter) return;
      state.rankFilter = newRankFilter;
      console.log('change new rank filter', newRankFilter);
    },
    setApplyFilter(state) {
      state.applyFilter++;
    },
    // setWaitingData(state, shouldWaiting: boolean) {
    //   state.waitingData = shouldWaiting;
    //   //console.log('CHASE WaitingData *****[SVO]*****/(^^)/ call  setWaitingData', state.waitingData);
    // },
    // setFirstLoading(state, firstLoading: boolean) {
    //   state.firstLoading = firstLoading;
    // },
    setStatus(state, status: string) {
      //LOADING, ERROR, EMPTY, DRAWING, READY, SEARCHING
      if (!status || status.isNullOrEmpty(status) || !connectomeStatus.includes(status)) {
        // console.log('*****[SVO]*****/(^^)/ call  setStatus', status);
        state.status = 'ERROR';
      }
      state.status = status;
    },
    setSearchTerms(state, searchTerms: string) {
      if (!searchTerms) {
        state.searchTerms = '';
        return;
      }
      state.searchTerms = searchTerms;
    },
    requestCenterToNode(state, node: MapNode) {
      if (!node) {
        state.nodeToCenter = null;
        return;
      }
      state.nodeToCenter = node;
      state.centerToNode++;
    },
    setCenterToNode(state, newNodeToCenter: MapNode) {
      if (!newNodeToCenter) {
        state.nodeToCenter = null;
        return;
      }
      state.nodeToCenter = newNodeToCenter;
    },
    setShow(state, show: boolean) {
      state.show = show;
    },
    setConnectomeDate(state, connectomeDate: string) {
      if (!connectomeDate) {
        state.connectomeDate = '';
        return;
      }
      state.connectomeDate = moment(connectomeDate).format('YYYY-MM-DD');
    },
  },
  actions: {
    getConnectome: async (context, payload: { connectomeId: string; scrapboards: Array<any> }) => {
      const resultMapNodes: { nodeList: Array<ConnectomeNode>; nodes: Array<MapNode> } = {
        nodeList: new Array<ConnectomeNode>(),
        nodes: new Array<MapNode>(),
      };
      const today = new Date();
      const newSignature =
        '[' + payload.connectomeId + ']' + payload.scrapboards.map(x => x.id + '(' + x.documentIdList?.join(':') + ')').join(';');

      // if (context.getters.getCurrentMapSignatureLoaded.localeCompare(newSignature) == 0) {
      //   return resultMapNodes;
      // }

      context.commit('setMapSignatureRequested', {
        newMapSignature: newSignature,
      });

      context.commit('setNewMap', { newNodes: new Array<MapNode>() });
      if (!payload.connectomeId || !payload.scrapboards) {
        context.commit('setConnectomeDate', today.toISOString());
        return resultMapNodes;
      }

      //console.log('*****[SVO]*****/(^^)/payload.scrapboards', payload.scrapboards);

      const bodyRequest = {
        connectomeId: payload.connectomeId,
        scrapBoardIds: payload.scrapboards.map(x => x.id),
        signatureMapString: newSignature,
        maxMainNode: 100,
        maxSubNode: 12,
      };
      context.commit('setConnectomeDate', '');
      context.commit('setStatus', 'LOADING');
      const apiCallConnectomeData = new Promise<any>((resolve, reject) => {
        axios
          .post(postConnectomeByScrapboardIdsURL, bodyRequest)
          .then(response => {
            // console.log('*****[SVO]*****/(^^)/ call  get Connectome by scrapboardId', response);

            if (response.status === 200) {
              context.commit('setStatus', '');
              if (response.data.body.signatureMapString?.localeCompare(context.getters.getMapSignatureRequested) == 0) {
                context.commit('setConnectomeDate', today.toISOString());
                resolve(response.data.body);
              } else {
                context.commit('setConnectomeDate', '');
                context.commit('setStatus', 'ERROR');
                reject();
              }
            } else {
              context.commit('setConnectomeDate', '');
              context.commit('setStatus', 'ERROR');
              reject();
            }
          })
          .catch(error => {
            context.commit('setConnectomeDate', '');
            context.commit('setStatus', 'ERROR');
            reject(error);
          });
      });

      const connectomeData = await apiCallConnectomeData;
      if (!connectomeData) {
        return resultMapNodes;
      }

      resultMapNodes.nodes = connectomeData?.nodes?.map(x => new MapNode(x));
      context.commit('setNewMap', { newNodes: connectomeData.nodes?.map(x => x) });
      if (!resultMapNodes.nodes) {
        context.commit('setConnectomeDate', '');
        context.commit('setStatus', 'ERROR');
      }

      if (resultMapNodes.nodes.length == 0) {
        context.commit('setConnectomeDate', today.toISOString());
        context.commit('setStatus', 'EMPTY');
      }
      context.commit('setCurrentMapSignatureLoaded', {
        newMapSignature: connectomeData?.signatureMapString,
      });
      return resultMapNodes;
    },
    getSubjectInvestmentGraph: async (context, payload: { index: number; depth: number; query: string }) => {
      const resultMapNodes: { nodeList: Array<ConnectomeNode>; nodes: Array<MapNode> } = {
        nodeList: new Array<ConnectomeNode>(),
        nodes: new Array<MapNode>(),
      };

      const bodyRequest = { queryIndex: payload.index, depth: payload.depth, query: payload.query };
      //console.log('*****[SVO]*****/(^^)/ bodyRequest', bodyRequest);
      context.commit('setConnectomeDate', '');
      context.commit('setStatus', 'LOADING');
      const apiCallConnectomeData = new Promise<any>((resolve, reject) => {
        axios
          .post(postInvestmentGraphURL, bodyRequest, {
            headers: {
              'Content-Type': 'application/json',
            },
          })
          .then(response => {
            //console.log('*****[SVO]*****/(^^)/ call  get Connectome by scrapboardId', response);

            if (response.status === 200) {
              context.commit('setStatus', '');
              resolve(response.data.body);
            } else {
              context.commit('setConnectomeDate', '');
              context.commit('setStatus', 'ERROR');
              reject();
            }
          })
          .catch(error => {
            context.commit('setConnectomeDate', '');
            context.commit('setStatus', 'ERROR');
            reject(error);
          });
      });

      const investmentGraphData = await apiCallConnectomeData;
      if (!investmentGraphData) {
        context.commit('setConnectomeDate', '');
        return;
      }

      console.log('*****[SVO]*****/(^^)/ call  get investment by targetSubject', investmentGraphData);

      if (investmentGraphData?.nodeList.length == 0) {
        context.commit('setConnectomeDate', '');
        context.commit('setStatus', 'EMPTY');
      }
      //create nodes
      const mapNodes = new Array<MapNode>();
      const nodes = investmentGraphData?.nodeList?.map(x => new MapNode(x));
      const links = investmentGraphData?.linkList?.map(x => new MapLink(x));
      let maxAmount = 0;
      let minAmount = Number.MAX_SAFE_INTEGER;
      nodes.forEach((node: MapNode, index: number, array: MapNode[]) => {
        // if (
        //   // node.type.toUpperCase().localeCompare('FUNDING_ROUND') == 0 ||
        //   // node.type.toUpperCase().localeCompare('INVESTMENTCOMPANY') == 0 ||
        //   // node.type.toUpperCase().localeCompare('COMPANY') == 0
        // ) {
        //   node.isMain = true;
        //}
        if (node.fundingRoundAmount || node.allFundingAmount) {
          node.hoverLabel =
            node.label +
            ' ' +
            (node.fundingRoundAmount ? node.fundingRoundAmount : '[full]' + node.allFundingAmount) +
            (node.announcedDate ? ' ' + node.announcedDate : '');
          if (maxAmount < (node.fundingRoundAmount ? node.fundingRoundAmount : node.allFundingAmount)) {
            maxAmount = node.fundingRoundAmount ? node.fundingRoundAmount : node.allFundingAmount;
          }
          if (minAmount > (node.fundingRoundAmount ? node.fundingRoundAmount : node.allFundingAmount)) {
            minAmount = node.fundingRoundAmount ? node.fundingRoundAmount : node.allFundingAmount;
          }
          // node.sizeFactor = 1 + (node.fundingRoundAmount ? node.fundingRoundAmount / 100000000 : node.allFundingAmount / 100000000);
        }
        // links
        //   .filter(link => link.to.localeCompare(node.id) == 0)
        //   .forEach(link => {
        //     const targetNode = array.find(x => x.id.localeCompare(link.from) == 0);
        //     if (targetNode) {
        //       const maptarget = new MapTarget(null);
        //       maptarget.id = targetNode.id;
        //       maptarget.relationInfos = new Array<MapLinkInfo>();
        //       const linkInfo = new MapLinkInfo(null);
        //       linkInfo.name = link.label;
        //       linkInfo.count = 1;
        //       maptarget.relationInfos.push(linkInfo);
        //       node.targetNodes.push(maptarget);
        //     }
        //   });

        links
          .filter(link => link.from.localeCompare(node.id) == 0)
          .forEach(link => {
            const targetNode = array.find(x => x.id.localeCompare(link.to) == 0);
            if (targetNode) {
              const maptarget = new MapTarget(null);
              maptarget.id = targetNode.id;
              maptarget.relationInfos = new Array<MapLinkInfo>();
              const linkInfo = new MapLinkInfo(null);
              linkInfo.name = link.label;
              linkInfo.count = 1;
              maptarget.relationInfos.push(linkInfo);
              node.targetNodes.push(maptarget);
            }
          });
      });

      const unitSizeFactor = 4 / (maxAmount - minAmount);
      nodes.forEach((node: MapNode, index: number, array: MapNode[]) => {
        if (node.fundingRoundAmount || node.allFundingAmount) {
          node.sizeFactor =
            1 +
            (node.fundingRoundAmount
              ? (node.fundingRoundAmount - minAmount) * unitSizeFactor
              : (node.allFundingAmount - minAmount) * unitSizeFactor);
        }
      });

      resultMapNodes.nodes = nodes.map(x => new MapNode(x));
      context.commit('setConnectomeDate', investmentGraphData?.updatedDate);
      context.commit('setNewMap', { newNodes: nodes.map(x => x) });
      context.commit('setCurrentMapSignatureLoaded', {
        newMapSignature: '[' + payload.query + ']',
      });

      console.log('*****[SVO]*****/(^^)/ call  get investment by targetSubject', resultMapNodes);
      return resultMapNodes;
    },
    displayTmpConnectome: async (
      context,
      payload: {
        docIds: Array<string>;
        connectomeId: string;
        lang: string;
      }
    ) => {
      const resultMapNodes: { nodeList: Array<ConnectomeNode>; nodes: Array<MapNode> } = {
        nodeList: new Array<ConnectomeNode>(),
        nodes: new Array<MapNode>(),
      };

      if (!payload.connectomeId || !payload.lang) {
        return resultMapNodes;
      }

      axios.defaults.headers.common['connectomeId'] = payload.connectomeId;
      axios.defaults.headers.common['lang'] = payload.lang;

      const newCollection = new ContextualMemoryCollection(null);
      newCollection.connectomeId = payload.connectomeId;
      newCollection.lang = payload.lang;
      newCollection.documentIdList = payload.docIds.map(x => x);
      const apiCallConnectomeData = new Promise<any>((resolve, reject) => {
        axios
          .post(postCreateTmpCollectionURL, newCollection)
          .then(res => resolve(res))
          .catch(err => reject(err));
      });

      return apiCallConnectomeData
        .then(res => {
          if (!res.data.body) {
            return resultMapNodes;
          }
          const tmpContext = res.data.body;
          //console.log('create temp collection', tmpContext);

          if (!tmpContext.connectomeNodeList) {
            return resultMapNodes;
          }

          const connectome: Array<ConnectomeNode> = tmpContext.connectomeNodeList.map(x => new ConnectomeNode(x));
          resultMapNodes.nodeList = connectome.map(x => x);
          //console.log('create temp connectome', connectome);
          //create nodes
          const mapNodes = new Array<MapNode>();

          const documentslist: Array<string> = payload.docIds.map(x => x);

          if (!documentslist || documentslist.length == 0) {
            return resultMapNodes;
          }

          if (connectome.length < 1) {
            return resultMapNodes;
          }
          connectome.forEach((connectomeNode: ConnectomeNode, index: number, array: ConnectomeNode[]) => {
            if (!connectomeNode || connectomeNode.relatedDocuments?.length < 1) {
              return;
            }

            const mapNode = new MapNode(null);
            mapNode.id = connectomeNode.id;
            mapNode.label = connectomeNode.label;
            mapNode.nodesLinked = connectomeNode.linkedNodes
              ? connectomeNode.linkedNodes.map(x => new String(x).toString())
              : new Array<string>();
            // mapNode.isDisable = connectomeNode.disable;
            // mapNode.rank = index + 1;
            mapNode.score = connectomeNode.weight;
            const ands = connectome
              .filter(n1 => connectomeNode.linkedNodes.includes(n1.id))
              .sort((a, b) => (a.weight > b.weight ? -1 : 1))
              .map(n2 => n2.label);
            const exp = buildBinaryCascadeFromArray('or', ands);

            if (!exp) {
              mapNode.data = connectomeNode.label;
            } else {
              const expfinal = new BinaryExpression();
              expfinal.type = 'and';
              expfinal.left = connectomeNode.label;
              expfinal.right = exp;
              mapNode.data = expfinal;
            }
            mapNodes.push(mapNode);
          });
          resultMapNodes.nodes = mapNodes.map(x => x);
          context.commit('setNewMap', { newNodes: mapNodes.map(x => x) });
          return resultMapNodes;
        })
        .catch(reason => {
          // console.log('Reason', reason);
          // console.log('Reason  getTmpConnectomeData', payload);
        });
    },
  },
};

function convertLocalStorageToArrayString(obj: any) {
  if (!obj) {
    return new Array<string>();
  }

  const map = JSON.parse(obj);
  const list = new Array<string>();
  for (let i = 0; i < map.length; i++) {
    list.push(map[i]);
  }
  if (!map) {
    return new Array<string>();
  }

  return list;
}

function convertLocalStorageToMapStringArrayString(obj: any) {
  if (!obj) {
    return new Map<string, Array<string>>();
  }

  const map = new Map<string, Array<string>>(JSON.parse(obj));
  if (!map) {
    return new Map<string, Array<string>>();
  }
  return map;
}

function convertLocalStorageToArrayNodes(obj: any) {
  if (!obj) {
    return new Array<ConnectomeNode>();
  }

  const list = new Array<ConnectomeNode>(JSON.parse(obj));
  if (!list) {
    return new Array<ConnectomeNode>();
  }
  return list;
}

function buildBinaryCascadeFromArray(type: string, listValues: Array<string>) {
  if (!listValues) {
    return null;
  }

  if (listValues.length < 1) {
    return null;
  }

  if (listValues.length == 1) {
    return listValues[0];
  }

  const exp = new BinaryExpression();
  exp.type = type;
  exp.left = listValues[0];
  listValues.splice(0, 1);
  exp.right = buildBinaryCascadeFromArray(type, listValues);

  return exp;
}
